import { Link } from 'react-router-dom';
import styled from 'styled-components';
import theme from '@styles/theme';

export const Wrapper = styled.div`
    margin: 150px auto;
    width: 343px;
`;
export const Title = styled.h2`
    margin-bottom: 20px;
    font-size: 24px;
    font-family: PretendardMedium, sans-serif;
    text-align: center;
`;
export const SubTitle = styled.div`
    margin-bottom: 40px;
    font-size: 14px;
    color: ${theme.colors.grayIconColor};
    text-align: center;
`;
export const LinkButton = styled(Link)`
    padding: 0 8px;
    font-size: 14px;
    text-align: right;
    color: ${theme.colors.grayIconColor};
    cursor: pointer;
    &:first-of-type {
        border-right: ${theme.colors.grayIconColor} 1px solid;
    }
`;
export const SearchArea = styled.div``;
export const SearchText = styled.div`
    font-size: 14px;
    color: ${theme.colors.grayIconColor};
`;
export const Empty = styled.div`
    padding: 40px 12px;
`;
export const Result = styled.div`
    padding: 20px 12px;
`;
